import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
function MenuHandler() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMobileOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  if (loading) {
    return <div className="h-10 w-24 animate-pulse rounded bg-muted/20" />;
  }
  const items = (menuItems.length > 0 ? menuItems : [{
    id: "home",
    label: "Home",
    href: "/HomePage"
  }, {
    id: "services",
    label: "Services",
    href: "/ServicesPage"
  }, {
    id: "deliverables",
    label: "Deliverables",
    href: "/DeliverablesPage"
  }, {
    id: "training",
    label: "Training",
    href: "/TrainingPage"
  }, {
    id: "team",
    label: "Team",
    href: "/TeamPage"
  }, {
    id: "contact",
    label: "Contact",
    href: "/ContactPage"
  }]).sort((a, b) => (a.order || 0) - (b.order || 0)).filter(item => !["Home2", "Services2", "Deliverables2"].includes(item.label));
  return <>
      {}
      <div className="hidden md:block">
        <NavigationMenu viewport={false}>
          <NavigationMenuList className="gap-6">
            {items.map(item => <NavigationMenuItem key={item.id}>
                <NavigationMenuLink asChild>
                  <Link to={item.href || "#"} className="relative group font-mono text-base font-bold tracking-widest uppercase text-white/70 transition-colors hover:text-[#14b8a6] hover:bg-transparent py-2">
                    {item.label}
                    <span className="absolute bottom-0 left-1/2 h-[2px] w-0 -translate-x-1/2 bg-[#14b8a6] transition-all duration-300 ease-out content-[''] group-hover:w-full" />
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>)}
          </NavigationMenuList>
        </NavigationMenu>
      </div>

      {}
      <button onClick={() => setIsMobileOpen(!isMobileOpen)} className="text-white md:hidden focus:outline-none" aria-label="Toggle menu">
        {isMobileOpen ? <X className="h-6 w-6 text-[#14b8a6]" /> : <Menu className="h-6 w-6 text-[#14b8a6]" />}
      </button>

      {}
      {isMobileOpen && <div className="absolute left-0 top-full w-full border-b border-[#14b8a6]/20 bg-[#0d1b2a]/95 backdrop-blur-xl md:hidden animate-in slide-in-from-top-5 fade-in duration-200 text-white">
          <nav className="container mx-auto flex flex-col gap-4 p-6">
            {items.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="font-mono text-sm font-bold tracking-wider text-white/80 hover:text-[#14b8a6] transition-colors" onClick={() => setIsMobileOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <section data-section-id="22417" id="navigation-header" className="relative z-50 bg-[#0d1b2a] text-white">
      <header className="fixed top-0 left-0 right-0 z-50 w-full transition-all duration-500 border-b border-[#14b8a6]/20 py-2 bg-[#0d1b2a] text-white">
        <div className="container mx-auto flex h-16 items-center justify-between px-4 md:px-6">
          {}
          <Link to="/HomePage" className="flex items-center gap-2 focus:outline-none group">
            <div className="relative flex h-30 w-30 items-center justify-center overflow-hidden transition-transform duration-300 group-hover:scale-105">
              <img src="https://climbing-leech-1.10web.cloud/wp-content/uploads/2026/03/image_ibyrt3a0.jpg" alt="Projectora Consulting Limited" className="object-contain !h-[140px]" />
            </div>
          </Link>

          {}
          <MenuProvider menu_id="49" className="flex items-center">
            <MenuHandler />
          </MenuProvider>
        </div>
      </header>
    </section>;
}